import { Link } from "react-router-dom";
import { categories } from "@/mocks/manga";

export default function CategoryNav() {
  return (
    <section className="max-w-7xl mx-auto px-4 md:px-6 -mt-10 relative z-10">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {categories.map((cat) => (
          <Link
            key={cat.key}
            to={`/category/${cat.key}`}
            className="group flex items-center gap-4 bg-background-50 rounded-xl p-5 transition-all duration-300 hover:scale-[1.02] cursor-pointer"
          >
            <div className="w-14 h-14 rounded-xl bg-accent-100 flex items-center justify-center flex-shrink-0">
              <i className={`${cat.icon} text-2xl text-accent-600`}></i>
            </div>
            <div>
              <h3 className="text-base font-semibold text-foreground-950 group-hover:text-primary-500 transition-colors">
                {cat.label}
              </h3>
              <p className="text-sm text-foreground-500 mt-0.5">{cat.subLabel}</p>
            </div>
            <i className="ri-arrow-right-s-line text-foreground-400 group-hover:translate-x-1 transition-transform ml-auto"></i>
          </Link>
        ))}
      </div>
    </section>
  );
}